/**
 * "Pause om X min" badge — pinned under the clock on the dark hero.
 * Bathroom / cigarette / coffee planning, in two words.
 *
 * Surfaces only when the NEXT level is a break (we don't have visibility
 * two levels out without an API change). When zero minutes remain, copy
 * shifts to "Pause snart" — players will see "0 min" otherwise and
 * misread it as "no break."
 */
const NextBreakBadge = ({ minutes }: { minutes: number }) => {
  const copy = minutes <= 0 ? 'Pause snart' : `Pause om ${minutes} min`
  return (
    <span
      className="inline-flex items-center gap-1.5 bg-warn/20 text-warn px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider"
      aria-label={copy}
    >
      <span aria-hidden>☕</span>
      {copy}
    </span>
  )
}

export default NextBreakBadge
